import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import ResidentIDHelper from '../../helpers/ResidentIDHelper';
import CheckoutOverlay from '../CheckoutOverlay';
import useStyles from './Overlay.styles';

export function PCCCOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      className={classes.pcccOverlay}
      data-test="PCCCOverlay"
      title="checkout.address.field.label.korean.pcc.title"
    >
      <ResidentIDHelper isOverlay isForeignCitizen />
      <div
        className={classes.buttonContainer}
        data-test="PCCCOverlay__buttonContainer"
      >
        <Button
          id="CCCOverlay__closeButton"
          className="PCCCOverlay__closeButton"
          primary
          fullWidth
          onClick={props.hideOverlay}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

PCCCOverlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
};

export default connect(null, {hideOverlay})(PCCCOverlay);
